
import { Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { handleFetchError, ensureRequestBodySize } from "../../ErrorHandling.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ImportResult, ImportResult_$reflection } from "../../Shared/Importer.js";
import { State, Msg } from "./Types.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { FormState__setValidation, FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty } from "../../Shared/Shared.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ofNullable } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ensureValidToken } from "../../Auth.js";
import { keyValueList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { fetch$ } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { onBlobReceived, getBlob } from "../../CommunicationV2.js";

export function validateCmd(formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ImportResult_$reflection()));
            }, refreshOn)))(true);
        }));
    }, ["/api/import/validate/tools", formData], (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(7, [Item_1])));
}

export function importCmd(importData) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ImportResult_$reflection()));
        }, refreshOn)))(true);
    })), ["/api/import/tools", toString(0, Auto_generateBoxedEncoder_437914C6(ImportResult_$reflection(), undefined, undefined, undefined)(importData))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(7, [Item_1])));
}

export function init() {
    return [new State(undefined, FormState_get_empty()), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(undefined, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0])), Cmd_errorToast("importer.failed_imported_data")];
            }
            else {
                return [new State(response.fields[0], FormState_get_empty()), Cmd_successToast("importer.successfully_imported_data")];
            }
        }
        case 2:
            return [new State(undefined, FormState__startLoading(state.FormState)), validateCmd(msg.fields[0])];
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(undefined, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0])), Cmd_none()];
            }
            else {
                return [new State(response_1.fields[0], FormState_get_empty()), Cmd_none()];
            }
        }
        case 4:
            return [state, Cmd_OfPromise_either_1((tupledArg_1) => {
                const body_1 = tupledArg_1[2];
                return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let pr;
                    const tenant = ofNullable(localStorage.getItem("tenant"));
                    return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
                        const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                            let matchValue_1;
                            return append((matchValue_1 = _arg, (matchValue_1 == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue_1]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                                const matchValue_1_1 = tenant;
                                if (matchValue_1_1 == null) {
                                    return empty();
                                }
                                else {
                                    return singleton(["X-ONE-Tenant", matchValue_1_1]);
                                }
                            }))));
                        })), 0)]);
                        const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
                        return fetch$(addPrefix(tupledArg_1[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg_1[1]])));
                    });
                }));
            }, ["/api/import/tools/template", "template.csv", undefined], (tupledArg) => (new Msg(5, [tupledArg[0], tupledArg[1]])), (Item_2) => (new Msg(7, [Item_2])))];
        case 5:
            return [state, getBlob(msg.fields[0], msg.fields[1], (tupledArg_2) => (new Msg(6, [tupledArg_2[0], tupledArg_2[1]])), (Item_5) => (new Msg(7, [Item_5])))];
        case 6: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 7:
            return [new State(state.Import, FormState__setValidation(FormState_get_empty(), "global", "importer.csv_validation_failure")), Cmd_none()];
        default: {
            const matchValue = state.Import;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const import$ = matchValue;
                return [new State(state.Import, FormState__startLoading(state.FormState)), importCmd(new ImportResult(import$.Headers, import$.Rows, import$.RowsLength, import$.IsValid, import$.IsImported, import$.CsvErrorImportType, import$.BusinessUnitId, import$.UnknownCategories, msg.fields[0], import$.AssignmentFailures))];
            }
        }
    }
}

